import React from "react";
import { Button, Dialog } from "@material-ui/core";
import { Field, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFavPassenger,
  updateFavPassenger,
} from "../CrudAndRedux/ProfileCrud";
import { getAllFavPassengers } from "../../Homepage/pages/widgets/components/cruds";
import { toast } from "react-toastify";
import { actions } from "../CrudAndRedux/ProfileRedux";
import { Input, Select } from "../../../../_metronic/_partials/controls";

const PassengerXS = (props) => {
  const [open, setOpen] = React.useState(false);
  const [current, setCurrent] = React.useState(null);
  const [delDialog, setDelDialog] = React.useState(false);

  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: accountState } = useSelector((state) => ({
    state: state.profile,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelClickOpen = () => {
    setDelDialog(true);
  };

  const handleDelClose = () => {
    setDelDialog(false);
  };

  const genderHandler = (genderId) => {
    switch (genderId) {
      case 1:
        return "آقا";
      // case 2:
      //   return "کودک";
      case 0:
        return "خانم";
    }
  };

  return (
    <>
      <Dialog
        open={delDialog}
        keepMounted
        onClose={handleDelClose}
        PaperProps={{
          style: {
            height: "13rem",
            width: "35rem",
            borderRadius: "13px",
            border: "1px solid #d9d9d9",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="text-right d-flex flex-column h-100 p-8">
          <h4>آیا قصد حذف این مسافر را دارید؟</h4>
          <div
            className="d-flex justify-content-between mb-2 mt-auto"
            style={{ gap: "10px" }}
          >
            <Button
              style={{
                border: "1px solid #6dd06d",
                borderRadius: 13,
                color: "#6dd06d",
                width: "50%",
                height: "3.5rem",
              }}
              onClick={() => {
                handleDelClose();
              }}
            >
              <h6
                className="d-flex align-items-center my-auto"
                style={{ color: "#6dd06d" }}
              >
                <i
                  className="fa fa-times mr-2 my-1"
                  style={{
                    opacity: "0.75",
                    color: "#6dd06d",
                    cursor: "pointer",
                  }}
                ></i>{" "}
                انصراف
              </h6>
            </Button>
            <Button
              style={{
                border: "1px solid #D03636",
                borderRadius: 13,
                color: "#D03636",
                height: "3.5rem",

                width: "50%",
              }}
              onClick={() => {
                // handleDelClickOpen();
                deleteFavPassenger(authState.user.token, current.id)
                  .then((res) => {
                    handleDelClose();
                    getAllFavPassengers(authState.user.token).then((res) => {
                      dispatch(actions.getAllFavPassengers(res.data.data));
                    });
                  })
                  .catch(() => {
                    toast.error("مشکلی در ارتباط با سرور به وجود آمد");
                  });
              }}
            >
              <h6
                className="d-flex align-items-center my-auto"
                style={{ color: "#D03636" }}
              >
                <i
                  className="fa fa-trash mr-2 my-2"
                  style={{ opacity: "0.75", color: "#D03636" }}
                ></i>{" "}
                حذف
              </h6>
            </Button>
          </div>
        </div>
      </Dialog>
      {props.data
        ? props.data.map((el) => {
            return (
              <div
                className="my-2 d-block flex-column p-5 bg-white"
                style={{ border: "1px solid lightgray", borderRadius: 13 }}
              >
                <div className="d-flex justify-content-between my-3">
                  <h6>نام :‌</h6>
                  <h6
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                  >
                    {el.passengerFirstName}
                  </h6>
                </div>
                <div className="d-flex justify-content-between my-3">
                  <h6>نام خانوادگی :‌</h6>
                  <h6
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                  >
                    {el.passengerLastName}
                  </h6>
                </div>
                <div className="d-flex justify-content-between my-3">
                  <h6>کدملی :‌</h6>
                  <h6
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                  >
                    {el.passengerNationalCode}
                  </h6>
                </div>
                <div className="d-flex justify-content-between my-3">
                  <h6>جنسیت :‌</h6>
                  <h6
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                  >
                    {el.passengerGender && genderHandler(el.passengerGender)}
                  </h6>
                </div>

                <div
                  className="line w-100 mx-auto"
                  style={{ marginBlock: "5%", borderBottom: "1px solid gray" }}
                ></div>
                <div className="d-flex flex-column my-2">
                  <Button
                    className="w-100 my-1"
                    style={{
                      border: "1.7px solid #6dd06d",
                      borderRadius: 10,
                      color: "#6dd06d",
                      height: "3rem",
                    }}
                    onClick={() => {
                      setCurrent(el);
                      handleClickOpen();
                    }}
                  >
                    <h6 className="d-flex align-items-center my-auto w-100">
                      <i
                        className="fa fa-edit mr-2 my-1"
                        style={{
                          color: "#6dd06d",
                          cursor: "pointer",
                        }}
                      ></i>{" "}
                      <span
                        className="mx-auto"
                        style={{ fontSize: "13px", color: "#6dd06d" }}
                      >
                        ویرایش
                      </span>
                    </h6>
                  </Button>
                  <Button
                    className="w-100 my-1"
                    style={{
                      border: "1.7px solid #d03636",
                      borderRadius: 10,
                      color: "#d03636",
                      height: "3rem",
                    }}
                    onClick={() => {
                      // deleteFavPassenger;
                      handleDelClickOpen();
                      setCurrent(el);
                    }}
                  >
                    <h6 className="d-flex align-items-center my-auto w-100">
                      <i
                        className="fa fa-trash mr-2 my-2"
                        style={{ color: "#d03636" }}
                      ></i>{" "}
                      <span
                        className="mx-auto"
                        style={{ fontSize: "13px", color: "#d03636" }}
                      >
                        حذف
                      </span>
                    </h6>
                  </Button>
                </div>
              </div>
            );
          })
        : null}
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            borderRadius: "13px",
            border: "1px solid #d9d9d9",
          },
        }}
      >
        <div style={{ padding: 30 }}>
          <Formik
            enableReinitialize
            initialValues={current ? current : {}}
            onSubmit={(values) => {
              updateFavPassenger(authState.user.token, values, current.id)
                .then((res) => {
                  getAllFavPassengers(authState.user.token).then((res) => {
                    dispatch(actions.getAllFavPassengers(res.data.data));
                  });
                })
                .catch(() => {
                  toast.error("مشکلی در ارتباط با سرور به وجود آمد");
                });
            }}
          >
            {({ handleSubmit, setFieldValue, values }) => {
              return (
                <>
                  <div className="row mb-4">
                    <h2 className="" style={{ opacity: "0.60" }}>
                      <b>مشخصات مسافر</b>
                    </h2>
                  </div>

                  <div className="row ">
                    <div className="col-12 col-md-4 my-2">
                      <Field
                        name="passengerFirstName"
                        placeholder="نام"
                        style={{
                          height: "4rem",
                          borderRadius: 13,
                          border: "1px solid #d9d9d9",
                          outline: "none",
                        }}
                        onChange={(e) => {
                          setFieldValue("passengerFirstName", e.target.value);
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div className="col-12 col-md-4 my-2">
                      <Field
                        name="passengerLastName"
                        placeholder="نام خانوادگی"
                        style={{
                          height: "4rem",
                          borderRadius: 13,
                          border: "1px solid #d9d9d9",
                          outline: "none",
                        }}
                        onChange={(e) => {
                          setFieldValue("passengerLastName", e.target.value);
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div className="col-12 col-md-4 my-2">
                      <Field
                        name="passengerNationalCode"
                        placeholder="کد ملی"
                        style={{
                          height: "3rem",
                          borderRadius: 13,
                          border: "1px solid #d9d9d9",
                          outline: "none",
                        }}
                        onChange={(e) => {
                          setFieldValue(
                            "passengerNationalCode",
                            e.target.value
                          );
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div
                      className="col-12 col-md-4 my-2"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <Select
                        style={{
                          borderRadius: "13px",
                          border: "1px solid #d9d9d9",
                          backgroundColor: "white",
                          outline: "none",
                        }}
                        name="passengerGender"
                        className="w-100 h-100"
                        onChange={(e) => {
                          setFieldValue("passengerGender", e.target.value);
                        }}
                        placeholder={"جنسیت"}
                      >
                        <option>جنسیت را انتخاب کنید</option>
                        <option value={1}>آقا</option>
                        <option value={0}>خانم</option>
                        {/* <option value={2}>کودک</option> */}
                      </Select>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap mt-4 justify-content-around">
                    <div
                      className="col-12 col-md-6 my-2 p-1"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="w-100 h-100"
                        onClick={() => handleClose()}
                        style={{
                          border: "1px solid #d9d9d9",
                          color: "white",
                          backgroundColor: "#d9d9d9",
                          borderRadius: "13px",
                        }}
                      >
                        <h6 className="my-auto text-white">انصراف</h6>
                      </Button>
                    </div>
                    <div
                      className="col-12 col-md-6 my-2 p-1"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="w-100 h-100 text-white"
                        style={{
                          border: "1px solid #6dd06d",
                          color: "white",
                          backgroundColor: "#6dd06d",
                          borderRadius: "13px",
                        }}
                        onClick={() => {
                          handleSubmit();
                          handleClose();
                        }}
                      >
                        <h6 className="my-auto text-white">ثبت</h6>
                      </Button>
                    </div>
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </Dialog>
    </>
  );
};

export default PassengerXS;
